import type { IconSvgObject } from './types';

const WifiConnected02Icon: IconSvgObject = [
  ["path", { d: "M18.5 11.5C14.7324 8.16667 9.5 8.16667 5.5 11.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M2 8C8.31579 2.66669 15.6842 2.66668 22 7.99989", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M9 18.0001C9 18.0001 10 18.0001 11 20.0001C11 20.0001 13.4766 16.1017 16 14.501", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default WifiConnected02Icon;
